/* =============================================================================
   DAILE Mono — the photo customizer as a pop-up (R8 prototype). sections/mn-czpop.liquid (header group,
   so this file runs on every Mono page while the section's switch is on) + assets/mn-czpop.css.

   ROLLBACK: untick "Открывать кастомайзер поверх страницы" in the section → the section prints nothing and
   every link goes to the separate page /pages/customizer as before. Test without it: ?mn_czpop=0 (kept for the
   browser tab in sessionStorage 'mn-czpop-off'; ?mn_czpop=1 switches it back on).

   WHY NOT <iframe src="/pages/customizer">: Shopify sends every storefront page with X-Frame-Options: DENY and
   CSP frame-ancestors 'none' — the browser refuses to show it in a frame, even on the same domain.
   So the pop-up FETCHES the customizer page (same request the separate page makes) and writes it into an empty
   same-origin <iframe>: document.open() → history.replaceState(<customizer address>) → document.write(html).
   Inside, it is exactly the separate page (its own CSS / JS / scroll, ?set= ?glue= ?edit= ?pdp= work), the
   page around stays untouched.

   A. Parent page (any Mono page except the customizer page itself and the theme editor)
      - a click on a link to /pages/customizer (any locale prefix; query kept) opens <dialog data-mn-czpop>
        (top layer: above the cart drawer; the offer pop-up never auto-opens over it) and builds the iframe
        from <that address>&mn_embed=1 (+ view=mono-customizer while Mono is previewed with ?view=mono…);
      - scripted jumps there (custom PDP "upload your photo" → IndexedDB hand-off → location.href) are caught
        through the Navigation API where the browser has it; elsewhere they open the separate page;
      - preload (setting): the page HTML is fetched once the page is idle when it has a customizer link, and on
        hover / focus / pointerdown of such a link (cached 3 min — no script runs until the pop-up opens);
      - history: opening pushes "#customize" — the phone's back button closes the pop-up (Android's back
        gesture reaches the dialog's "cancel" first — same result); Esc and × close it too. With a photo in
        (or card text / NFC link typed, or the cart being updated) "Leave without saving?" comes first
        (setting). A reload with #customize just shows the page;
      - the iframe never leaves the customizer. After "Add to cart" / "Update in cart" the customizer opens
        <pdp_url>?daile_cart=open — inside the pop-up that address comes here instead (see B.1) → the pop-up
        closes, the page's own DAILE cart drawer opens and re-reads /cart.js (window.DAILE_CART); on the cart
        page, or without a drawer, the page goes to that address (replacing the #customize entry). A link
        inside the customizer → the whole page goes there. Should the frame still unload on its own, the pop-up
        closes and, if /cart.js changed since opening, the drawer opens;
      - window.mnCzpop = { open(url), close(), isOpen() }; events on document: 'mn-czpop:open',
        'mn-czpop:close', 'mn-czpop:added'.
   B. Inside the iframe (html.mn-embed, set by the section's inline script before first paint)
      - mn-czpop.css hides the page chrome;
      - 1. the customizer's config pdp_url is swapped for a javascript: call that posts the real address to the
        parent (the legacy file is not edited); link clicks out of it go to the parent; 'gone' on pagehide;
      - Esc (when no customizer dialog is open) → asks the parent to close;
      - 'ready' is posted once the customizer has mounted (the parent then fades the iframe in).
   ============================================================================= */
(() => {
  'use strict';

  const w = window;
  const d = document;
  const html = d.documentElement;
  if (w.mnCzpop) return;

  const ORIGIN = w.location.origin;
  const LOCALE = '(?:[a-z]{2}(?:-[a-z0-9]{2,4})?\\/)?';
  const CZ_PATH = new RegExp('^\\/' + LOCALE + 'pages\\/customizer\\/?$', 'i');
  const CART_PATH = new RegExp('^\\/' + LOCALE + 'cart\\/?$', 'i');
  const HASH = '#customize';

  const parseUrl = (raw) => {
    if (raw == null || raw === '') return null;
    try { return new URL(String(raw), w.location.href); } catch (e) { return null; }
  };
  const isCustomizer = (url) => !!url && url.origin === ORIGIN && CZ_PATH.test(url.pathname);
  const stripHash = (href) => String(href).split('#')[0];
  const emit = (name, detail) => {
    try { d.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) { /* old browsers */ }
  };

  /* B. Inside the pop-up ======================================================= */

  function initEmbed() {
    w.mnCzpop = Object.freeze({ embedded: true, open() {}, close() {}, isOpen: () => false });
    if (html.classList.contains('mn-embed--leave')) return; // not the customizer: the inline script reported it

    const post = (type, extra) => {
      try { w.parent.postMessage(Object.assign({ mnCzpop: type }, extra || {}), ORIGIN); } catch (e) { /* parent gone */ }
    };

    // 1. "Add to cart" / "Update in cart" end with location.href = pdp_url + '?daile_cart=open'
    //    (assets/dv-customizer.js). A frame cannot load a storefront page (X-Frame-Options), and the Navigation
    //    API has no events in a written document — so the customizer's pdp_url (read when it mounts, after this
    //    script) becomes a javascript: call that hands the real address to the parent. No history entry.
    const cfgEl = d.querySelector('script[data-dv-cz-config]');
    if (cfgEl) {
      try {
        const cfg = JSON.parse(cfgEl.textContent || '{}');
        const real = String(cfg.pdp_url || '/products/custom-puzzle');
        if (real.indexOf('javascript:') !== 0) {
          w.mnCzpopDone = () => {
            const glue = real.indexOf('?') > -1 ? '&' : '?';
            post('leave', { url: new URL(real + glue + 'daile_cart=open', w.location.href).href });
          };
          cfg.pdp_url = 'javascript:void(window.mnCzpopDone&&window.mnCzpopDone())//';
          cfgEl.textContent = JSON.stringify(cfg);
        }
      } catch (e) { /* keep the original: the frame then unloads and the parent checks the cart ('gone') */ }
    }

    // 2. Links out of the customizer go to the parent (the whole page goes there).
    d.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.hasAttribute('download')) return;
      const target = (a.getAttribute('target') || '').toLowerCase();
      if (target && target !== '_self') return;
      const url = parseUrl(a.getAttribute('href'));
      if (!url || !/^https?:$/.test(url.protocol)) return;
      if (url.origin === ORIGIN && url.pathname === w.location.pathname && url.search === w.location.search && url.hash) return;
      e.preventDefault();
      post('leave', { url: url.href });
    });
    // Anything else that still navigates (where the Navigation API has events) …
    const nav = w.navigation;
    if (nav && typeof nav.addEventListener === 'function') {
      nav.addEventListener('navigate', (e) => {
        if (!e.cancelable || e.hashChange || e.downloadRequest) return;
        if (e.destination && e.destination.sameDocument) return;
        if (e.navigationType === 'traverse') return;
        const url = parseUrl(e.destination && e.destination.url);
        if (!url || !/^https?:$/.test(url.protocol)) return;
        e.preventDefault();
        post('leave', { url: url.href });
      });
    }
    // … or unloads the frame: the parent closes the pop-up and looks at the cart.
    w.addEventListener('pagehide', () => post('gone'));

    // 3. Esc closes the pop-up — unless a customizer dialog / menu is open (it closes that first).
    w.addEventListener('keydown', (e) => {
      if ((e.key !== 'Escape' && e.key !== 'Esc') || e.isComposing) return;
      if (d.querySelector('dialog[open], details[open][data-dv-autoclose]')) return;
      post('esc');
    }, true);

    // 4. The customizer's action bar gets its "floating" look from an IntersectionObserver on the top window's
    //    viewport, which a frame never matches: mark it against this frame's viewport (.mn-stuck, mn-czpop.css).
    const markNavs = () => {
      if (!('IntersectionObserver' in w)) return;
      let io;
      try {
        io = new IntersectionObserver((entries) => entries.forEach((e) => {
          const r = e.boundingClientRect;
          const rb = e.rootBounds;
          const stuck = !!rb && e.isIntersecting && e.intersectionRatio < 1 && r.bottom > rb.bottom - 0.5 && r.top > rb.top;
          e.target.classList.toggle('mn-stuck', stuck);
        }), { root: d, threshold: [0, 1], rootMargin: '0px 0px -1px 0px' });
      } catch (e) { return; } // no document root in this browser: the bar stays as it is
      d.querySelectorAll('.dv-cz__nav').forEach((n) => io.observe(n));
    };

    // 5. Ready once the customizer has mounted (dv.js mounts it on DOMContentLoaded).
    let sent = false;
    const ready = () => { if (!sent) { sent = true; markNavs(); post('ready'); } };
    const wait = () => {
      const t0 = Date.now();
      const tick = () => {
        if ((w.DVCustomizer && w.DVCustomizer.instance) || Date.now() - t0 > 4000) { ready(); return; }
        setTimeout(tick, 40);
      };
      tick();
    };
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => setTimeout(wait, 0), { once: true });
    else setTimeout(wait, 0);
  }

  /* A. Parent page ============================================================== */

  function initParent() {
    const dlg = d.querySelector('dialog[data-mn-czpop]');
    if (!dlg || dlg.getAttribute('data-design') === 'true' || html.classList.contains('mn-design')) return;

    // Test switch: ?mn_czpop=0 / ?mn_czpop=1 (remembered for the tab).
    const OFF_KEY = 'mn-czpop-off';
    let off = false;
    try {
      const q = new URLSearchParams(w.location.search).get('mn_czpop');
      if (q === '0') w.sessionStorage.setItem(OFF_KEY, '1');
      else if (q === '1') w.sessionStorage.removeItem(OFF_KEY);
      off = w.sessionStorage.getItem(OFF_KEY) === '1';
    } catch (e) {
      off = /[?&]mn_czpop=0(?:&|$)/.test(w.location.search);
    }
    // 22.10 (analytics: 93 % phones, most from Instagram / TikTok): inside in-app browsers the pop-up (the whole
    // customizer page re-run in an iframe, with every app script) costs memory a WebView may not have — a big photo
    // then reloads the page «silently». There the links simply open /pages/customizer as a normal page.
    const IN_APP = /Instagram|FBAN|FBAV|FB_IAB|BytedanceWebview|musical_ly|TikTok|Snapchat|Pinterest|LinkedInApp|Line\//i.test(w.navigator.userAgent || '');
    if (off || IN_APP || CZ_PATH.test(w.location.pathname)) return;

    // A reload while the pop-up was open: just the page.
    if (w.location.hash === HASH) {
      try { w.history.replaceState(null, '', stripHash(w.location.href)); } catch (e) { /* ignore */ }
    }

    const bar = dlg.querySelector('[data-mn-czpop-bar]');
    const body = dlg.querySelector('[data-mn-czpop-body]');
    const slow = dlg.querySelector('[data-mn-czpop-slow]');
    const pageLink = dlg.querySelector('[data-mn-czpop-page]');
    const ask = dlg.querySelector('[data-mn-czpop-confirm]');
    const keepBtn = dlg.querySelector('[data-mn-czpop-keep]');
    const PRELOAD = dlg.getAttribute('data-preload') !== 'false';
    const CONFIRM = dlg.getAttribute('data-confirm') !== 'false';
    const FRAME_TITLE = dlg.getAttribute('data-frame-title') || 'Make it personal';
    const TTL = 3 * 60 * 1000;
    const reduced = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    let preview = html.hasAttribute('data-mn-preview');
    try { preview = preview || /^mono/i.test(new URLSearchParams(w.location.search).get('view') || ''); } catch (e) { /* */ }

    const frameUrl = (url) => {
      const u = new URL(url.href);
      if (preview && !u.searchParams.has('view')) u.searchParams.set('view', 'mono-customizer');
      u.searchParams.set('mn_embed', '1');
      u.hash = '';
      return u.href;
    };
    const pageUrl = (url) => {
      const u = new URL(url.href);
      u.searchParams.delete('mn_embed');
      if (preview && !u.searchParams.has('view')) u.searchParams.set('view', 'mono-customizer');
      return u.href;
    };

    const S = {
      open: false, frame: null, target: '', page: '', ready: false, opener: null, cart: null,
      pushed: false, ignorePop: 0, ignoreT: 0, slowT: 0, closeT: 0, bypass: false, t0: 0,
    };

    /* the customizer page's HTML (fetched ahead, no script runs) ----------------- */

    const cache = new Map(); // target → { t, p: Promise<{ href, html }> }
    const fetchHtml = (target) => {
      const hit = cache.get(target);
      if (hit && Date.now() - hit.t < TTL) return hit.p;
      const p = fetch(target, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then((r) => {
        if (!r.ok) throw new Error('customizer ' + r.status);
        const final = parseUrl(r.url);
        const href = r.redirected && isCustomizer(final) ? final.href : target;
        if (r.redirected && !isCustomizer(final)) throw new Error('redirected');
        return r.text().then((text) => {
          if (text.indexOf('data-dv-customizer') === -1) throw new Error('no customizer');
          return { href, html: text };
        });
      });
      cache.set(target, { t: Date.now(), p });
      p.catch(() => { if (cache.get(target) && cache.get(target).p === p) cache.delete(target); });
      return p;
    };

    /* iframe ------------------------------------------------------------------ */

    const dropFrame = () => {
      if (S.frame) S.frame.remove();
      S.frame = null;
      S.ready = false;
      body.classList.remove('is-ready');
    };

    const markReady = () => {
      if (!S.frame || S.ready) return;
      S.ready = true;
      S.frame.classList.add('is-ready');
      body.classList.add('is-ready');
      clearTimeout(S.slowT);
      if (slow) slow.hidden = true;
      emit('mn-czpop:ready', { ms: Math.round(performance.now() - S.t0) });
    };

    function onFrameLoad(e) {
      const f = e.currentTarget;
      if (f !== S.frame) return;
      let doc = null;
      let href = '';
      try { doc = f.contentDocument; href = f.contentWindow.location.href; } catch (err) { doc = null; }
      if (!doc) { gone(); return; } // an error page: the frame still tried to load another address
      if (href === 'about:blank' || doc.readyState !== 'complete') return;
      if (!doc.documentElement.classList.contains('mn-embed')) { goPage(); return; } // the page has no pop-up support
      markReady();
    }

    const buildFrame = (href, text) => {
      dropFrame();
      const f = d.createElement('iframe');
      f.className = 'mn-czpop__frame';
      f.setAttribute('data-mn-czpop-frame', '');
      f.setAttribute('title', FRAME_TITLE);
      f.setAttribute('allow', 'autoplay; fullscreen; clipboard-write; web-share');
      body.appendChild(f); // about:blank, same origin
      S.frame = f;
      S.ready = false;
      const fw = f.contentWindow;
      const doc = f.contentDocument;
      doc.open(); // the document takes this page's address …
      fw.history.replaceState(null, '', href); // … and then the customizer's (no history entry)
      f.addEventListener('load', onFrameLoad);
      doc.write(text);
      doc.close();
    };

    /* state of the customizer inside (same origin) ------------------------------ */

    const isDirty = () => {
      if (!S.frame || !S.ready) return false;
      try {
        const fw = S.frame.contentWindow;
        const root = fw.document.querySelector('[data-dv-customizer]');
        if (root && (root.inert || root.getAttribute('aria-busy') === 'true')) return true; // adding to cart
        const api = fw.DVCustomizer && fw.DVCustomizer.instance;
        if (!api || typeof api.getState !== 'function') return false;
        const st = api.getState() || {};
        return !!(st.photo
          || (st.card && st.card.added && String(st.card.text || '').trim())
          || (st.nfc && st.nfc.enabled && String(st.nfc.url || '').trim()));
      } catch (e) {
        return true;
      }
    };

    /* page around ---------------------------------------------------------------- */

    // Scroll lock. The customizer scrolls its steps into view with scrollIntoView(), which also scrolls the
    // page around the frame (overflow: hidden does not stop a script) — keep the page where it was.
    let pinY = null;
    const pin = () => {
      if (pinY != null && Math.abs(w.scrollY - pinY) > 1) w.scrollTo({ top: pinY, left: 0, behavior: 'instant' });
    };
    const lock = () => {
      const sbw = Math.max(0, w.innerWidth - html.clientWidth);
      html.style.setProperty('--mn-czpop-sbw', `${sbw}px`);
      html.classList.add('mn-czpop-lock');
      if (pinY == null) {
        pinY = w.scrollY;
        w.addEventListener('scroll', pin, { passive: true });
      }
    };
    const unlock = () => {
      html.classList.remove('mn-czpop-lock');
      html.style.removeProperty('--mn-czpop-sbw');
      if (pinY != null) {
        w.removeEventListener('scroll', pin);
        pin();
        pinY = null;
      }
    };

    const closeDrawer = () => {
      const c = d.getElementById('daile-cart');
      if (!c || !c.classList.contains('is-open')) return;
      const x = c.querySelector('[data-daile-cart-close]');
      if (x) x.click();
    };

    // The custom PDP photo upload shows a busy state until the page unloads — it does not unload now.
    const resetPdpUpload = () => {
      d.querySelectorAll('[data-mn-upload-zone].is-busy').forEach((z) => z.classList.remove('is-busy'));
      d.querySelectorAll('input[data-mn-upload]').forEach((i) => { try { i.value = ''; } catch (e) { /* */ } });
    };

    const ROOT = (() => {
      const r = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    })();
    const cartKey = () => fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => r.json())
      .then((c) => (c.items || []).map((i) => i.key + ':' + i.quantity).join('|'))
      .catch(() => null);

    /* history ------------------------------------------------------------------ */

    const push = () => {
      try {
        w.history.pushState({ mnCzpop: 1 }, '', stripHash(w.location.href) + HASH);
        S.pushed = true;
      } catch (e) {
        S.pushed = false;
      }
    };
    const popOurEntry = () => {
      if (!S.pushed) return;
      S.pushed = false;
      if (!(w.history.state && w.history.state.mnCzpop)) return;
      S.ignorePop += 1;
      clearTimeout(S.ignoreT);
      S.ignoreT = setTimeout(() => { S.ignorePop = 0; }, 1500);
      w.history.back();
    };

    /* confirm -------------------------------------------------------------------- */

    const asking = () => !!ask && !ask.hidden;
    const showAsk = () => {
      if (!ask) return;
      ask.hidden = false;
      if (bar) bar.inert = true;
      body.inert = true;
      if (keepBtn) { try { keepBtn.focus({ preventScroll: true }); } catch (e) { keepBtn.focus(); } }
    };
    const hideAsk = (focusFrame) => {
      if (!asking()) return;
      ask.hidden = true;
      if (bar) bar.inert = false;
      body.inert = false;
      if (focusFrame && S.frame) { try { S.frame.focus(); } catch (e) { /* */ } }
    };

    /* open / close ------------------------------------------------------------------ */

    function open(url, opts) {
      const o = opts || {};
      if (S.open || !isCustomizer(url)) return;
      clearTimeout(S.closeT);
      if (S.frame) dropFrame(); // a closing pop-up that has not finished yet
      const target = frameUrl(url);
      S.t0 = performance.now();
      S.target = target;
      S.page = pageUrl(url);
      if (pageLink) pageLink.setAttribute('href', S.page);
      const fromDrawer = !!(o.opener && o.opener.closest && o.opener.closest('#daile-cart'));
      closeDrawer();
      if (o.scripted) resetPdpUpload();
      S.opener = fromDrawer ? null : (o.opener || d.activeElement);
      S.cart = null;
      cartKey().then((k) => { if (S.target === target) S.cart = k; });

      hideAsk(false);
      if (slow) slow.hidden = true;
      lock();
      try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
      S.open = true;
      html.classList.add('mn-czpop-open');
      if (reduced.matches) dlg.classList.add('is-open');
      else w.requestAnimationFrame(() => w.requestAnimationFrame(() => { if (S.open) dlg.classList.add('is-open'); }));
      push();

      clearTimeout(S.slowT);
      S.slowT = setTimeout(() => { if (S.open && !S.ready && slow) slow.hidden = false; }, 7000);

      fetchHtml(target).then((res) => {
        if (!S.open || S.target !== target) return;
        try {
          buildFrame(res.href, res.html);
        } catch (e) {
          console.warn('[mn-czpop] could not build the pop-up, opening the page', e);
          goPage();
        }
      }).catch((e) => {
        console.warn('[mn-czpop] customizer page not loaded, opening the page', e);
        if (S.open && S.target === target) goPage();
      });
      emit('mn-czpop:open', { url: S.page });
    }

    function doClose(opts) {
      const o = opts || {};
      if (!S.open) return;
      S.open = false;
      S.target = '';
      hideAsk(false);
      clearTimeout(S.slowT);
      html.classList.remove('mn-czpop-open');
      dlg.classList.remove('is-open');
      if (o.fromHistory) S.pushed = false;
      else popOurEntry();
      const opener = S.opener;
      S.opener = null;
      const end = () => {
        try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
        unlock();
        dropFrame();
        if (o.restoreFocus !== false && opener && opener.isConnected && typeof opener.focus === 'function') {
          try { opener.focus({ preventScroll: true }); } catch (e) { /* */ }
        }
        emit('mn-czpop:close', { reason: o.reason || '' });
        if (typeof o.then === 'function') o.then();
      };
      clearTimeout(S.closeT);
      if (reduced.matches || o.instant) end();
      else S.closeT = setTimeout(end, 320);
    }

    // why: 'user' (×, Esc, backdrop, dialog cancel) | 'back' (history)
    function requestClose(why) {
      if (!S.open) return;
      if (asking()) {
        if (why === 'back') doClose({ fromHistory: true, reason: 'back' }); // a second "back" while asking = leave
        return;
      }
      if (CONFIRM && isDirty()) {
        if (why === 'back') push(); // keep the entry while we ask
        showAsk();
        return;
      }
      doClose({ fromHistory: why === 'back', reason: why });
    }

    // Leave the pop-up for a real page load (no animation; the #customize entry is replaced).
    function navigateAway(href) {
      S.open = false;
      S.target = '';
      clearTimeout(S.slowT);
      html.classList.remove('mn-czpop-open');
      try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
      unlock();
      dropFrame();
      S.bypass = true;
      if (S.pushed) w.location.replace(href);
      else w.location.assign(href);
    }

    function goPage() {
      if (!S.page) { doClose({ instant: true }); return; }
      navigateAway(S.page);
    }

    const openDrawer = () => {
      const cart = w.DAILE_CART;
      try { cart.open(); } catch (e) { /* */ }
      try {
        const r = typeof cart.refresh === 'function' ? cart.refresh() : null;
        if (r && typeof r.catch === 'function') r.catch(() => {});
      } catch (e) { /* */ }
    };

    // After "Add to cart": the customizer wanted to show the product page with the drawer open.
    function finish(url) {
      emit('mn-czpop:added', { url: url.href });
      const cart = w.DAILE_CART;
      const onCartPage = CART_PATH.test(w.location.pathname);
      if (onCartPage || !cart || typeof cart.open !== 'function') {
        navigateAway(onCartPage ? stripHash(w.location.href) : url.href);
        return;
      }
      doClose({ reason: 'added', restoreFocus: false, then: openDrawer });
    }

    // The iframe unloaded on its own (browsers without the Navigation API): show the cart if it changed.
    function gone() {
      if (!S.open) { dropFrame(); return; }
      const before = S.cart;
      doClose({ reason: 'gone', instant: true });
      if (before == null) return;
      cartKey().then((now) => {
        if (now == null || now === before) return;
        emit('mn-czpop:added', { url: '' });
        if (CART_PATH.test(w.location.pathname)) { w.location.reload(); return; }
        if (w.DAILE_CART && typeof w.DAILE_CART.open === 'function') openDrawer();
      });
    }

    function handleLeave(href) {
      const url = parseUrl(href);
      if (!S.open) { dropFrame(); return; }
      if (url && /[?&]daile_cart=open(?:&|$)/.test(url.search)) { finish(url); return; }
      if (!url) { doClose({ instant: true }); return; }
      if (isCustomizer(url)) { rebuild(url); return; } // the customizer reloading / re-opening itself
      navigateAway(url.href);
    }

    // A frame cannot load a storefront address itself (X-Frame-Options): write the new page in again.
    function rebuild(url) {
      const target = frameUrl(url);
      S.target = target;
      S.page = pageUrl(url);
      dropFrame();
      cache.delete(target);
      fetchHtml(target).then((res) => {
        if (S.open && S.target === target) buildFrame(res.href, res.html);
      }).catch(() => { if (S.open && S.target === target) goPage(); });
    }

    /* events ------------------------------------------------------------------------ */

    w.addEventListener('message', (e) => {
      if (e.origin !== ORIGIN || !e.data || typeof e.data.mnCzpop !== 'string') return;
      if (!S.frame || e.source !== S.frame.contentWindow) return;
      const type = e.data.mnCzpop;
      if (type === 'ready') markReady();
      else if (type === 'esc') { if (asking()) hideAsk(true); else requestClose('user'); }
      else if (type === 'leave') handleLeave(String(e.data.url || ''));
      else if (type === 'gone') setTimeout(() => { if (S.open && S.frame && e.source === S.frame.contentWindow) gone(); }, 0);
    });

    dlg.addEventListener('click', (e) => {
      const t = e.target;
      if (t === dlg) { requestClose('user'); return; } // desktop: the dimmed page around the panel
      if (!(t instanceof Element)) return;
      if (t.closest('[data-mn-czpop-close]')) { requestClose('user'); return; }
      if (t.closest('[data-mn-czpop-keep]')) { hideAsk(true); return; }
      if (t.closest('[data-mn-czpop-discard]')) { doClose({ reason: 'discard' }); return; }
      if (t.closest('[data-mn-czpop-page]')) { e.preventDefault(); goPage(); }
    });
    dlg.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      e.preventDefault(); // no native close: we decide (and may ask first)
      e.stopPropagation();
      if (asking()) hideAsk(true);
      else requestClose('user');
    });
    dlg.addEventListener('cancel', (e) => { // Android back gesture / close requests
      e.preventDefault();
      if (asking()) hideAsk(true);
      else requestClose('user');
    });
    dlg.addEventListener('close', () => { // closed by the browser anyway (repeated close requests)
      if (S.open) doClose({ instant: true, reason: 'forced' });
    });

    w.addEventListener('popstate', (e) => {
      if (S.ignorePop > 0) { S.ignorePop -= 1; return; }
      if (!S.open) return;
      if (e.state && e.state.mnCzpop) return;
      S.pushed = false;
      requestClose('back');
    });

    // Links to the customizer (bubbling: handlers on the link itself run first and may change its href).
    const linkUrl = (a) => {
      if (!a || a.hasAttribute('download') || a.closest('[data-mn-czpop-skip]')) return null;
      const target = (a.getAttribute('target') || '').toLowerCase();
      if (target && target !== '_self') return null;
      const url = parseUrl(a.getAttribute('href'));
      return isCustomizer(url) ? url : null;
    };
    const linkOf = (e) => (e.target && e.target.closest ? e.target.closest('a[href]') : null);

    d.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = linkOf(e);
      const url = linkUrl(a);
      if (!url) return;
      e.preventDefault();
      open(url, { opener: a });
    });

    // Scripted jumps to the customizer (custom PDP photo upload, other scripts).
    const nav = w.navigation;
    if (nav && typeof nav.addEventListener === 'function') {
      nav.addEventListener('navigate', (e) => {
        if (S.bypass || S.open) return;
        if (!e.cancelable || e.hashChange || e.downloadRequest || e.formData) return;
        if (e.destination && e.destination.sameDocument) return;
        if (e.navigationType !== 'push' && e.navigationType !== 'replace') return;
        const url = parseUrl(e.destination && e.destination.url);
        if (!isCustomizer(url)) return;
        e.preventDefault();
        open(url, { scripted: true });
      });
    }

    // Preload: only the HTML (no script runs before the pop-up opens).
    if (PRELOAD) {
      const warm = (e) => {
        const url = linkUrl(linkOf(e));
        if (url) fetchHtml(frameUrl(url)).catch(() => {});
      };
      d.addEventListener('pointerdown', warm, { capture: true, passive: true });
      d.addEventListener('pointerover', (e) => { if (e.pointerType === 'mouse') warm(e); }, { passive: true });
      d.addEventListener('focusin', warm);
      // Once idle, on a page that links to the customizer: its HTML + the customizer's own files (CDN cache).
      const idle = () => {
        const conn = navigator.connection;
        if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
        const a = Array.from(d.querySelectorAll('a[href*="customizer"]')).find((x) => linkUrl(x));
        if (!a) return;
        fetchHtml(frameUrl(linkUrl(a))).catch(() => {});
        (dlg.getAttribute('data-assets') || '').split(/\s+/).filter(Boolean).forEach((href) => {
          const l = d.createElement('link');
          l.rel = 'prefetch';
          l.href = href;
          d.head.appendChild(l);
        });
      };
      const later = () => setTimeout(() => (w.requestIdleCallback ? w.requestIdleCallback(idle, { timeout: 4000 }) : idle()), 2500);
      if (d.readyState === 'complete') later();
      else w.addEventListener('load', later, { once: true });
    }

    // bfcache: a page restored after leaving through the pop-up is clean.
    w.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      S.bypass = false;
      if (!S.open) { unlock(); dropFrame(); }
    });

    w.mnCzpop = Object.freeze({
      open: (href) => { const u = parseUrl(href); if (isCustomizer(u)) open(u, {}); },
      close: () => requestClose('user'),
      isOpen: () => S.open,
    });
  }

  if (html.classList.contains('mn-embed')) initEmbed();
  else initParent();
})();
